// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__4mJX6","label":"Labeled_label__hu0_3","divider":"Labeled_divider__DAqZi"};